import e from "react";
import $ from "classnames";
import { t as E } from "./utils-Ci4OZEP4.es.js";
import { u as B } from "./ThemeProvider--i7ESlT5.es.js";
import { u as h } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as u } from "./index-BB-Wk85r.es.js";
import { I as k } from "./InputError-BEWrKIXS.es.js";
import './RadioGroup.css';const w = "Radio-module__radioButton___83sOM", C = "Radio-module__dark___YNElO", G = "Radio-module__compere___UpoCn", S = "Radio-module__label___Znh-K", D = "Radio-module__outline___yqS85", I = "Radio-module__fill___fXQyZ", x = "Radio-module__error___MN9E1", M = "Radio-module__radioButtonSvg___H9P5E", T = "Radio-module__radioGroup___WbS8D", o = {
  radioButton: w,
  dark: C,
  default: "Radio-module__default___DHlbp",
  compere: G,
  label: S,
  outline: D,
  fill: I,
  error: x,
  radioButtonSvg: M,
  radioGroup: T
}, y = e.forwardRef(
  ({
    value: r,
    name: s,
    label: a,
    selected: i = !1,
    onSelect: n,
    tabIndex: c = 0,
    labelVariant: d = "Body2",
    size: m = 26,
    id: _,
    ariaLabelledBy: t,
    error: R = !1
  }, b) => {
    const g = B(), v = h(), N = u[d] ?? u.Body2, l = m / 16, p = {
      cy: `${l / 2}rem`,
      cx: `${l / 2}rem`
    };
    return /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: b,
        id: _,
        role: "radio",
        "aria-checked": i,
        "aria-labelledby": t ?? E(`${s}-${r}`),
        tabIndex: c,
        className: $(o.radioButton, o[g], {
          [o.error]: R,
          [o.dark]: v
        }),
        onClick: () => n(r),
        onKeyDown: (f) => {
          f.key === " " && (f.preventDefault(), n(r));
        }
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: o.radioButtonSvg,
          style: {
            width: `${l}rem`,
            height: `${l}rem`
          }
        },
        /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ e.createElement(
          "circle",
          {
            ...p,
            r: `${l / 3.25}rem`,
            className: o.outline
          }
        ), i && /* @__PURE__ */ e.createElement(
          "circle",
          {
            ...p,
            r: `${l / 6.25}rem`,
            className: o.fill
          }
        ))
      ),
      a && /* @__PURE__ */ e.createElement(
        N,
        {
          tagName: "label",
          id: E(`${s}-${r}`),
          responsive: !0,
          className: o.label
        },
        a
      )
    );
  }
);
y.displayName = "Radio";
const z = ({
  id: r,
  children: s,
  error: a,
  label: i,
  ariaLabelledBy: n
}) => {
  const c = e.Children.toArray(s), d = a ? `${r}-error-message` : void 0, m = "radiogroup-label", _ = `${r}-radiogroup-name`;
  return /* @__PURE__ */ e.createElement("div", null, i && /* @__PURE__ */ e.createElement(u.Body, { tagName: "label", id: m, responsive: !0 }, i), /* @__PURE__ */ e.createElement(
    "div",
    {
      id: r,
      role: "radiogroup",
      className: o.radioGroup,
      "aria-invalid": !!a,
      "aria-labelledby": n ?? m,
      "aria-describedby": d
    },
    c.map(
      (t) => e.isValidElement(t) ? /* @__PURE__ */ e.createElement(
        y,
        {
          ...t.props,
          name: t.props.name || _,
          key: t.props.value,
          error: !!a
        }
      ) : null
    )
  ), d && a && /* @__PURE__ */ e.createElement(k, { id: d }, a));
};
export {
  y as R,
  z as a
};
